exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component=Banner] .header{margin-left:45px}[data-component=Banner] .footer{margin:0 45px;font-size:11px}[data-component=Banner] :nth-child(1n) a{color:#fff;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-2-1!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/lib/loader.js??ref--1-oneOf-2-3!./src/components/Banner/styles.scss
// module id = 1471
// module chunks = 0